import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../core';
import { IntegrationNotaFiscal } from './integration-nota-fiscal';
import { IntegrationPeriodicidade, periodicidadeDiaria, isPeriodicidadeDiaria, periodicidadeSemanal, isPeriodicidadeSemanal, periodicidadeMensal, isPeriodicidadeMensal, periodicidadeGeral, isPeriodicidadeGeral } from '../integration-periodicidade';
import { IntegrationNotaFiscalHttpService } from './services';

@Component({
    selector: 'sgt-integration-nota-fiscal-modal',
    templateUrl: './integration-nota-fiscal-modal.component.html',
    styleUrls: ['./integration-nota-fiscal-modal.component.less']
})
export class IntegrationNotaFiscalModalComponent implements OnInit {
    entity = new IntegrationNotaFiscal();
    elModal: any;
    @Output() afterExecuteIntegration = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    periodicidades: IntegrationPeriodicidade[] = [
        periodicidadeDiaria,
        periodicidadeSemanal,
        periodicidadeMensal,
        periodicidadeGeral
    ];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integrationNotaFiscalHttpService: IntegrationNotaFiscalHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#integrationNotaFiscalPeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.entity.clear();
    }

    open() {
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    private beforeExecute() {
        if (!this.isPeriodicidadeGeral()) {
            this.entity.dataInicialBase = null;
        }
    }

    /** Executa a integração de leitura das notas fiscais com os sistemas ERP's */
    execute() {
        if (this.form.valid) {
            this.beforeExecute();

            const task = new Task('Sincronizando notas fiscais com o ERP', 'Executando sincronização das notas fiscais com o sistema ERP');
            this.taskService.add(task, task.description);
            this.integrationNotaFiscalHttpService.execReadIntegration(this.entity)
                .subscribe(
                    () => {
                        this.taskService.success(task, 'Sincronização das notas fiscais com o sistema ERP realizada com sucesso');
                        this.afterExecuteIntegration.emit();
                    },
                    (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a sincronização das notas fiscais com o sistema ERP', error.message, error)
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para executar a sincronização das notas fiscais com o ERP', 'Informação');
        }
    }

    /** Verifica se a periodicidade selecionada é geral */
    isPeriodicidadeGeral(): boolean {
        if (!this.entity) {
            return false;
        }
        return isPeriodicidadeGeral(this.entity.periodicidade);
    }

    getDescricaoPeriodicidade(periodicidade: number): string {
        if (isPeriodicidadeDiaria(periodicidade)) {
            return 'Diária - Notas Fiscais emitidas nas últimas 24 horas';
        }  else if (isPeriodicidadeSemanal(periodicidade)) {
            return 'Semanal - Notas fiscais emitidas nos últimos 7 dias';
        } else if (isPeriodicidadeMensal(periodicidade)) {
            return 'Mensal - Notas fiscais emitidas a partir do mês anterior';
        } else if (isPeriodicidadeGeral(periodicidade)) {
            return 'Geral - Notas Fiscais emitidas a partir de uma data específica'
        }
        return '';
    }
}
